// extracted by mini-css-extract-plugin
export default {"input2":"Input2_input2__cekO-"};